import { CSSProperties, ReactNode } from "react";
import { Select as VoidSelect } from "@void-orbit/ui";

export interface SelectProps<TypeData> {
  keyProperty: keyof TypeData;
  name: string;
  label?: string;
  options: Array<TypeData>;
  selected: TypeData | null;
  showError?: boolean;
  error?: string;
  style?: CSSProperties;
  RenderOption: ( option: TypeData ) => ReactNode;
  handleSelect: ( option: TypeData ) => void;
};

export const Select = <TypeData,>({
  keyProperty,
  name,
  label,
  options,
  selected,
  showError = true,
  error,
  style,
  RenderOption,
  handleSelect,
}: SelectProps<TypeData> ) => {
  const valueOf = ( option: TypeData ) => String( option[ keyProperty ]);
  // O Chat mostra o selecionado mesmo quando ele saiu da lista (ex.: fila removida).
  const items = selected && !options.some(( option ) => valueOf( option ) === valueOf( selected )) ? [ selected, ...options ] : options;
  const byValue = new Map( items.map(( option ) => [ valueOf( option ), option ]));

  const select = (
    <VoidSelect
      name={ name || undefined }
      label={ label }
      error={ error }
      showMessage={ showError }
      options={ items.map(( option ) => ({ label: valueOf( option ), value: valueOf( option ) })) }
      value={ selected ? valueOf( selected ) : null }
      onChange={( value ) => {
        const option = byValue.get( value );
        if( option ) handleSelect( option );
      }}
      renderOption={( option ) => {
        const original = byValue.get( option.value );
        return original ? RenderOption( original ) : option.label;
      }}
    />
  );

  return style ? <div style={ style }>{ select }</div> : select;
};
